<template>
  <div class="rightconover">
    <div class="contentwidth">
      <lk-button class="butbox" type="lk_button_blue" @click="print">打印单据</lk-button>
      <div class="cargobox">
        <div class="boxtitle ta-c" style="margin-bottom: 20px;">仓房货位卡</div>
        <div id="printDialog" class="boxD">
          <div class="top">
            <div class="topB">
              <div>填制单位：<span class="inputTxt">{{ dataSet.storeroom }}</span></div>
              <div style="margin-right: 20mm;">填制日期：<span class="inputTxt">{{ dataSet.timeNew }}</span></div>
            </div>
          </div>
          <div class="borderAll" style="margin-bottom: 24mm;">
            <!-- 222总 -->
            <div class="flex justifyDefault hmm12 cloumn">
              <div class="wmm34">货位编号</div>
              <div class="wmm56 borderLeft">{{ dataSet.warehouseNumber }}</div>
              <div class="wmm28 borderLeft">粮油性质</div>
              <div class="wmm34 borderLeft">{{ dataSet.grainNature }}</div>
              <div class="wmm34 borderLeft">粮权归属</div>
              <div class="wmm68 borderLeft">{{ dataSet.grainBelong }}</div>
            </div>
            <div class="flex justifyDefault hmm12 cloumn borderTop">
              <div class="wmm34">仓型</div>
              <div class="wmm28 borderLeft">{{ dataSet.barType }}</div>
              <div class="wmm28 borderLeft">设计容量(吨)</div>
              <div class="wmm28 borderLeft">{{ (dataSet.capacityTotal / 1000).toFixed(3) }}</div>
              <div class="wmm34 borderLeft">入库时间</div>
              <div class="wmm34 borderLeft">{{ dataSet.inTime }}</div>
              <div class="wmm34 borderLeft">成货位时间</div>
              <div class="wmm34 borderLeft">{{ dataSet.becomeTime }}</div>
            </div>
            <div class="flex justifyDefault hmm12 cloumn borderTop">
              <div class="wmm34">粮油品种</div>
              <div class="wmm28 borderLeft">{{ dataSet.grainKind }}</div>
              <div class="wmm28 borderLeft">收获年度</div>
              <div class="wmm28 borderLeft">{{ dataSet.harvestYear }}</div>
              <div class="wmm34 borderLeft">实际数量(吨)</div>
              <div class="wmm34 borderLeft">{{ (dataSet.actualSize/1000).toFixed(3) }}</div>
              <div class="wmm34 borderLeft">管理方式</div>
              <div class="wmm34 borderLeft"></div>
            </div>
            <div class="flex justifyDefault hmm24 borderTop cloumn">
              <div class="wmm34">产地</div>
              <div class="wmm28 borderLeft">{{ dataSet.grainProArea }}</div>
              <div class="wmm28 borderLeft">价位(元/500g)</div>
              <div class="wmm28 borderLeft"></div>
              <div class="wmm34 borderLeft">储存方式</div>
              <div class="wmm34 borderLeft">{{ dataSet.packingWay }}</div>
              <div class="wmm34 borderLeft">包装存粮<br>包数</div>
              <div class="wmm34 borderLeft"></div>
            </div>
            <div class="flex justifyDefault hmm24 borderTop cloumn">
              <div class="wmm34">散存粮油体积(m³)</div>
              <div class="wmm28 borderLeft"></div>
              <div class="wmm28 borderLeft">长(m)<br></div>
              <div class="wmm28 borderLeft">宽(m)<br></div>
              <div class="wmm34 borderLeft">直径(m)<br></div>
              <div class="wmm34 borderLeft">高(m)<br></div>
              <div class="wmm34 borderLeft">平均包重<br>(kg)</div>
              <div class="wmm34 borderLeft"></div>
            </div>
            <div class="flex justifyDefault hmm12 cloumn borderTop">
              <div class="wmm34">等级</div>
              <div class="wmm28 borderLeft">{{ dataSet.foGrade}}</div>
              <div class="wmm28 borderLeft">出糙<br>(%)</div>
              <div class="wmm28 borderLeft"></div>
              <div class="wmm34 borderLeft" v-if="dataSet.grainKind=='大豆'">折合水分<br>(%)</div>
              <div class="wmm34 borderLeft" v-else>入仓水分<br>(%)</div>
              <div class="wmm34 borderLeft"></div>
              <div class="wmm34 borderLeft" v-if="dataSet.grainKind=='大豆'">杂质</div>
              <div class="wmm34 borderLeft" v-else>入仓杂质<br>(%)</div>
              <div class="wmm34 borderLeft"></div>
            </div>
            <div class="flex justifyDefault hmm12 cloumn borderTop" v-if="dataSet.grainKind=='大豆'">
              <div class="wmm34">完整粒率</div>
              <div class="wmm28 borderLeft"></div>
              <div class="wmm28 borderLeft">损伤粒率</div>
              <div class="wmm28 borderLeft"></div>
              <div class="wmm34 borderLeft">扣除体积</div>
              <div class="wmm34 borderLeft"></div>
              <div class="wmm34 borderLeft">管理形式</div>
              <div class="wmm34 borderLeft"></div>
            </div>
            <div class="flex justifyDefault hmm12 cloumn borderTop" v-if="dataSet.grainKind=='大豆'">
              <div class="wmm34">保管员</div>
              <div class="wmm28 borderLeft"></div>
              <div class="wmm28 borderLeft"></div>
              <div class="wmm28 borderLeft"></div>
              <div class="wmm34 borderLeft"></div>
              <div class="wmm34 borderLeft"></div>
              <div class="wmm34 borderLeft"></div>
              <div class="wmm34 borderLeft"></div>
            </div>
          </div>
          <div class="borderAll">
            <div class="flex justifyDefault hmm24 cloumn">
              <div class="wmm34 flipbox">
                <div class="w100">检验项目</div>
                <div class="line"></div>
                <div class="w100">检验时间</div>
              </div>
              <template v-if="dataSet.grainKind=='大豆'">
                <div class="wmm28 borderLeft">水分</div>
                <div class="wmm28 borderLeft">粗脂肪酸值<br>(mg/g)</div>
                <div class="wmm28 borderLeft">色泽、气味</div>
                <div class="wmm34 borderLeft"></div>
                <div class="wmm34 borderLeft"></div>
                <div class="wmm34 borderLeft"></div>
                <div class="wmm34 borderLeft">检测单位或检测人</div>
              </template>
              <template v-else>
                <div class="wmm28 borderLeft" v-if="dataSet.grainKind=='小麦'">容重<br>(g/L)</div>
                <div class="wmm28 borderLeft" v-else-if="dataSet.grainKind=='玉米'">容重<br>(g/L)</div>
                <div class="wmm28 borderLeft" v-else>出糙<br>(%)</div>
                <div class="wmm28 borderLeft">水分<br>(%)</div>
                <div class="wmm28 borderLeft">杂质<br>(%)</div>
                <div class="wmm34 borderLeft" v-if="dataSet.grainKind=='小麦'">面筋吸水量<br>(%)</div>
                <div class="wmm34 borderLeft" v-else>脂肪酸值<br>(mgKOH/100g)</div>
                <div class="wmm34 borderLeft" v-if="dataSet.grainKind=='小麦'">不完善率<br>(%)</div>
                <div class="wmm34 borderLeft" v-else-if="dataSet.grainKind=='玉米'">不完善率<br>(%)</div>
                <div class="wmm34 borderLeft" v-else>品尝评分值<br>(分)</div>
                <div class="wmm34 borderLeft">储存品质判定</div>
                <div class="wmm34 borderLeft">检验人</div>
              </template>
            </div>
            <template v-if="dataSet.grainKind=='大豆'">
              <div class="flex justifyDefault hmm12 cloumn borderTop" v-for="(el,ind) in dataSet.reports" :key="ind">
                <div class="wmm34">{{ el.checkTime }}</div>
                <div class="wmm28 borderLeft">{{ getReportInfo('水分',el.reportSons) }}</div>
                <div class="wmm28 borderLeft">{{ getReportInfo('粗脂肪酸值',el.reportSons) }}</div>
                <div class="wmm28 borderLeft">{{ getReportInfo('色泽、气味',el.reportSons) }}</div>
                <div class="wmm34 borderLeft"></div>
                <div class="wmm34 borderLeft"></div>
                <div class="wmm34 borderLeft"></div>
                <div class="wmm34 borderLeft">{{ el.inspector }}</div>
              </div>
            </template>
            <template v-else>
              <div class="flex justifyDefault hmm12 cloumn borderTop" v-for="(el,ind) in dataSet.reports" :key="ind">
                <div class="wmm34">{{ el.checkTime }}</div>
                <div class="wmm28 borderLeft" v-if="dataSet.grainKind=='小麦'">{{ getReportInfo('容重',el.reportSons) }}</div>
                <div class="wmm28 borderLeft" v-else-if="dataSet.grainKind=='玉米'">{{ getReportInfo('容重',el.reportSons) }}</div>
                <div class="wmm28 borderLeft" v-else>{{ getReportInfo('出糙',el.reportSons) }}</div>
                <div class="wmm28 borderLeft">{{ getReportInfo('水分',el.reportSons) }}</div>
                <div class="wmm28 borderLeft">{{ getReportInfo('杂质',el.reportSons) }}</div>
                <div class="wmm34 borderLeft" v-if="dataSet.grainKind=='小麦'">{{ getReportInfo('面筋吸水量',el.reportSons) }}</div>
                <div class="wmm34 borderLeft" v-else>{{ getReportInfo('脂肪酸值',el.reportSons) }}</div>
                <div class="wmm34 borderLeft" v-if="dataSet.grainKind=='小麦'">{{ getReportInfo('不完善率',el.reportSons) }}</div>
                <div class="wmm34 borderLeft" v-else-if="dataSet.grainKind=='玉米'">{{ getReportInfo('不完善率',el.reportSons) }}</div>
                <div class="wmm34 borderLeft" v-else>{{ getReportInfo('品尝评分值',el.reportSons) }}</div>
                <div class="wmm34 borderLeft">{{ el.remark }}</div>
                <div class="wmm34 borderLeft">{{ el.inspector }}</div>
              </div>
            </template>
            <div class="flex justifyDefault hmm12 cloumn borderTop">
              <div class="wmm34">备注</div>
              <div class="wmm28 borderLeft"></div>
              <div class="wmm28 borderLeft"></div>
              <div class="wmm28 borderLeft"></div>
              <div class="wmm34 borderLeft"></div>
              <div class="wmm34 borderLeft"></div>
              <div class="wmm34 borderLeft"></div>
              <div class="wmm34 borderLeft"></div>
            </div>
          </div>
          <div class="top">
            <div class="topB">
              <div>保管员：<span class="inputTxt"></span></div>
              <div style="margin-right: 20mm;">审核人：<span class="inputTxt"></span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import printJS from "print-js";
import { httpToken } from "@/utils/http";
import qs from "qs";

export default {
  name: "Detail",
  data() {
    return {
      dataSet: {},
      backModule: ''
    };
  },
  methods: {
    getReportInfo(str,data){
      console.log('str,data',str,data)
      for(let i=0;i<data.length;i++){
        if(data[i].item.indexOf(str)!=-1){
          return data[i].value
        }
      }
      return ''
    },
    // 打印
    print() {
      let nowHost = window.location.host.split(":");
      let nowPort = window.location.port;
      let header = `<h3 style="text-align: center;font-weight: normal;font-size:25px; margin:0; height:35mm; line-height:35mm;">仓房货位卡</h3>`;
      printJS({
        printable: "printDialog",
        type: "html",
        header: header,
        css: "http://" + nowHost[0] + ":" + nowPort + "/static/css/print.css?v=20230315",
        style: "",
        scanStyles: false,
      });
    },
    //返回
    goBack() {
      this.$emit('update:comName', this.backModule)
    },
    // 获取数据
    getQualityCard(id) {
      httpToken({
        url: '/granary-quality-card/findOne',
        method: 'post',
        data: qs.stringify({ id: id })
      }).then(res => {
        console.log(res)
        let Data = res.data.data
        Data.timeNew = Data.timeNew.slice(0, 10)
        Data.createDate = Data.createDate.slice(0, 10)
        this.dataSet = Data
        // this.dataSet.grainKind='大豆'
      })
    }
  },
  mounted() {
    if (this.$store.state.Quality.qualityId) {
      this.getQualityCard(this.$store.state.Quality.qualityId)
    }
    if (this.$store.state.Quality.qualityBack) {
      this.backModule = this.$store.state.Quality.qualityBack
    }
  }
};
</script>
<style scoped lang="scss">
@import url("/static/css/print.css");
.boxtitle{
  font-size:25px;
  font-weight: bold;
}
.rightconover {
  height: 100%;
  background-color: #f5f6fa;
  overflow: auto;

  .contentwidth {
    width: 100%;
    text-align: center;
    position: relative;
    .butbox{
      position: absolute;
      right: 50px;
      top: 60px;
    }
    .cargobox{
      margin-top: 20px;
      display: inline-block;
      padding: 40px;
      padding-bottom: 40px;
      background: #fff;
      box-shadow: 0 3px 7px 0 rgba(91, 117, 148, 0.26);
    }
    .boxD {
      margin-top: 30px;
    }

  }
}
</style>
